import React, { useEffect, useState } from 'react'
import { SectionLabel, SectionTitle, SectionWrapper } from '../Section'
import { Dropzone } from '../Form'
import { downloadStringAsFile, processCsvFile } from '../../Utils/Misc'
import {
  createCampaignShipments,
  getCampaignShipments,
} from '../../Containers/Campaigns/CreateEditCampaign/gql'
import { hideReduxModal, showReduxModal } from '../../Reducers/UI/actions'
import SubmitButton from '../Form/SubmitButton'
import { connect } from 'react-redux'
import { Col, Row } from 'react-bootstrap'
import LoadingIndicator from '../LoadingIndicator/LoadingIndicator'

function CampaignShipmentUpload({
  campaignId,
  showReduxModal,
  shipmentUploaded,
}) {
  const [file, setFile] = useState(null)
  const [errors, setErrors] = useState(null)
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    load()
  }, [])

  const load = () => {
    setLoading(true)
    getCampaignShipments(campaignId)
      .then(res => {
        setData(res)
      })
      .catch(err => setErrors(err))
      .finally(() => setLoading(false))
  }

  const onAttachFile = entryFiles => {
    let file = null
    if (typeof entryFiles[0] === 'undefined') {
      // Windows env
      const input = document.querySelector(
        '#ImportCityMetricsViewDropZoneContainer input',
      )
      if (!input) return null
      file = input.files.length && input.files[0]
    } else {
      file = entryFiles[0]
    }
    if (!file) return null
    setFile(file)
  }

  const uploadClick = () => {
    if (!file) {
      showReduxModal({
        title: 'Warning!',
        children: 'Attach a CSV file first',
        onConfirm: hideReduxModal,
        hideCancel: true,
      })
      return
    }

    if (data && data.shipmentData) {
      showReduxModal({
        title: 'Warning!',
        children: 'This action will replace the actual data.',
        onConfirm: uploadData,
        onCancel: hideReduxModal,
      })
      return
    }

    uploadData()
  }
  const uploadData = async () => {
    const { data, errors } = await processCsvFile(file)

    if (errors.length) {
      setErrors(errors)
    }

    createCampaignShipments(campaignId, data).then(() => {
      showReduxModal({
        title: 'Success!',
        children: 'New campaign shipments revision sent!',
        hideCancel: true,
        onConfirm: () => {
          load()
          shipmentUploaded()
        },
      })
    })
  }

  const downloadCsvExample = () => {
    downloadStringAsFile(
      `postalCode,amountSent`,
      `campaignShipments.csv`,
      `text/csv`,
    )
  }

  return (
    <SectionWrapper className="section-wrapper">
      <SectionTitle className="section-title">Campaign shipments</SectionTitle>
      <SectionLabel>
        Upload list of postalCodes and flyersSent to calculate taxes to be
        collected accordingly the destinations.
      </SectionLabel>
      {loading ? (
        <LoadingIndicator size={24} />
      ) : (
        <React.Fragment>
          <Col
            style={{
              marginTop: '12px',
            }}
          >
            <Dropzone
              mainLabel="Campaign shipments"
              input={{
                value: '',
                onChange: onAttachFile,
              }}
              meta={{}}
            />
          </Col>

          {data && data.shipmentData ? (
            <Col
              style={{
                padding: '14px',
              }}
            >
              <Row>Revision: {data.shipmentDataRevision}</Row>
              <Row>Rows: {data.shipmentData.length}</Row>
              <Row>
                Total flyers:{' '}
                {data.shipmentData.reduce((acc, d) => (acc += d.amountSent), 0)}
              </Row>
            </Col>
          ) : null}
        </React.Fragment>
      )}

      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
      <a onClick={downloadCsvExample} href="#">
        Download csv example
      </a>

      <Row>
        {errors && errors.message && <pre>{errors.message}</pre>}

        <Col
          xs={12}
          style={{
            paddingTop: '36px',
            display: 'flex',
            justifyContent: 'flex-end',
          }}
        >
          <SubmitButton onClick={uploadClick}>Upload</SubmitButton>
        </Col>
      </Row>
    </SectionWrapper>
  )
}

const mapDispatchToProps = { showReduxModal }

export default connect(
  null,
  mapDispatchToProps,
)(CampaignShipmentUpload)
